import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { reduxForm } from "redux-form";
import { scrollToFirstInvalidInput } from "../../../util/formHelpers";
import FormError from "../../common/FormError";
import SnippetDetailFields from "./SnippetDetailFields";

export const EDIT_SNIPPET_FORM_NAME = "EDIT_SNIPPET_FORM_NAME";

const EditSnippetForm = ({ error, change, touch, fieldLabels }) => (
  <form autoComplete="off">
    {error && <FormError errorMessage={error} />}
    <SnippetDetailFields
      fieldLabels={fieldLabels}
      editMode
      change={change}
      touch={touch}
      formName={EDIT_SNIPPET_FORM_NAME}
    />
  </form>
);

EditSnippetForm.propTypes = {
  error: PropTypes.string,
  change: PropTypes.func.isRequired,
  touch: PropTypes.func.isRequired,
  fieldLabels: PropTypes.object.isRequired,
};

EditSnippetForm.defaultProps = {
  error: null,
};

const mapStateToProps = () => ({});

const form = reduxForm({
  form: EDIT_SNIPPET_FORM_NAME,
  onSubmitFail: (errors) => scrollToFirstInvalidInput(errors),
});
const reduxData = connect(mapStateToProps);
export default compose(form, reduxData)(EditSnippetForm);
